import React from "react";
import { bikes } from "../data";
import Bike from "./ui/Bike.jsx";
// console.log(books);

const Discounted = () => {
  return (
    <section id="recent">
      <div className="container">
        <div className="row">
          <h2 data-aos='' data-aos-duration="3000" className="section__title">
            Discount <span className="purple">Bikes</span>
          </h2>
          <div className="books">
            {/* find the book price from 0 to 8 base on id */}
            {bikes
              .filter((bike) => bike.salePrice > 0)
              .slice(0, 8)
              .map((bike) => (
                <Bike bike={bike} key={bike.id} />
              ))
            }
          </div>
        </div>
      </div>
    </section>
  );
};

export default Discounted;
